var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('div',{staticClass:"loading-wrap d-flex justify-content-center",class:( _obj = {'global-loader': _vm.globalLoader}, _obj[("theme-" + _vm.theme)] = _vm.isTheme, _obj )},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-indicator-wrap"},[_c('div',{staticClass:"loading-indicator"})])}]

export { render, staticRenderFns }